module.exports = __webpack_public_path__ + "assets/img/22_245_big.a8f6f4b8.jpg";